import React from "react";

import { LoaderLayout } from "../components/atoms/loader/LoaderLayout";
import { Shop } from "./Shop";
import { useGetShopPreview } from "./useGetShopPreview";

type Props = {
  tenantId: string;
  brandId: string;
  shopId: string;
};
export const ShopPreviewContainer: React.FC<Props> = (props) => {
  const { shopInfo } = useGetShopPreview(props);
  if (shopInfo === undefined) return <LoaderLayout />;
  // TODO エラー・未ログインのハンドリング
  return <Shop {...props} shopInfo={shopInfo} />;
};
